export interface SetYearsAction {
    type: "INIT_YEARS";
    initialState: number[];
}

export const setYears = (initialState: number[]): SetYearsAction => ({
    type: "INIT_YEARS",
    initialState
});

export type YearsAction = SetYearsAction;
